import { GetPromotionPreviewResponse } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

/** What promoting a facility would write to the target, and anything that would stop it. */
export const getPromotionPreview = async (
  facilityId: number
): Promise<GetPromotionPreviewResponse> => {
  const { data } = await queryBuilder(
    'GET',
    `onboarding/promotion/${facilityId}`
  );
  return data;
};
